import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import ValueSection from './components/ValueSection';
import CategoryGrid from './components/CategoryGrid';
import CTASection from './components/CTASection';
import TrustSection from './components/TrustSection';
import BlogPreview from './components/BlogPreview';
import Footer from './components/Footer';
import JsonLd, { buildWebsiteSchema, buildWebPageSchema } from '@/components/feature/JsonLd';

export default function Home() {
  const websiteSchema = buildWebsiteSchema();
  const webPageSchema = buildWebPageSchema(
    'Ultimate Pandabuy Spreadsheet Database 2026 | pandabuy.wiki',
    'Discover the most complete Pandabuy Spreadsheet database for 2026. 10,000+ verified product entries organized by category, quality score, and price.',
    '/',
  );

  return (
    <main className="min-h-screen bg-background-50">
      <JsonLd data={websiteSchema} />
      <JsonLd data={webPageSchema} />
      <Navbar />
      <HeroSection />
      <ValueSection />
      <CategoryGrid />
      <CTASection />
      <TrustSection />
      <BlogPreview />
      <Footer />
    </main>
  );
}